<template>
  <div class="s-pre-order__wrapper">
    <div
      v-if="desktop"
      class="swiper-button-prev s-pre-order__prev-desktop"></div>
    <div v-if="!desktop" class="s-pre-order__header">
      {{ dictionaryData.title }}
    </div>

    <swiper
      :key="desktop ? 'desktop' : 'mobile'"
      :navigation="navigationConfig"
      slides-per-view="1"
      :space-between="35"
      @swiper="onSwiper"
      @slide-change="onSlideChange">
      <swiper-slide v-for="(record, index) in preOrderRecords" :key="index">
        <div class="s-pre-order__slide-content">
          <!-- Left side -->
          <div class="s-pre-order__left-section">
            <div v-if="desktop" class="s-pre-order__header">
              {{ dictionaryData.title }}
            </div>
            <div v-if="!desktop" class="s-pre-order__img">
              <img :src="record.thumb" :alt="record.title" />
            </div>
            <div class="s-pre-order__card">
              <div class="s-pre-order__main">
                <!-- <div class="s-pre-order__labels">
                  <div class="e-label e-label--playing">
                    <span>{{ dictionaryData.premier }}</span>
                    {{ showOpenDate(record.due) }}
                  </div>
                </div> -->

                <div class="s-pre-order__content">
                  <h2 class="s-pre-order__content__title">
                    {{ record.title }}
                  </h2>
                  <div class="s-pre-order__content__subtitle">
                    {{ record.subTitle }}
                  </div>
                  <div
                    class="s-pre-order__content__description"
                    v-html="record.desc"></div>
                </div>
                <div class="b-hor-align b-hor-align--gap-16">
                  <div v-if="record.pg" class="e-k">{{ record.pg }}</div>
                  <div
                    v-if="record.highSchool"
                    class="e-label e-label--high-school">
                    <span>{{ dictionaryData.highSchool }}</span>
                  </div>
                  <div
                    v-if="record.middleSchool"
                    class="e-label e-label--middle-school">
                    <span>{{ dictionaryData.middleSchool }}</span>
                  </div>
                  <div
                    v-if="record.elementarySchool"
                    class="e-label e-label--elementary-school">
                    <span>{{ dictionaryData.elementarySchool }}</span>
                  </div>
                  <!-- <div v-if="record.genre" class="movie-attr--movie">
                    {{ record.genre }}
                  </div> -->
                  <div v-if="record.dur" class="movie-attr--time">
                    <span>{{ record.dur }}</span>
                  </div>
                </div>
              </div>
              <div v-if="desktop" class="s-pre-order__btn-area">
                <a :href="record.url" class="s-pre-order__cta-btn">
                  <span>{{ dictionaryData.more }}</span>
                </a>
              </div>
            </div>
          </div>

          <!-- Right side -->
          <div v-if="desktop" class="s-pre-order__right-section">
            <div class="s-pre-order__img">
              <img :src="record.thumb" :alt="record.title" />
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div v-if="!desktop" class="s-pre-order__nav d-flex d-lg-none">
      <div class="swiper-button-prev s-pre-order__prev-mobile"></div>
      <div class="swiper-button-next s-pre-order__next-mobile"></div>
    </div>
    <a
      v-if="!desktop"
      :href="activeRecordUrl"
      :title="dictionaryData.more"
      target="_self"
      class="s-pre-order__cta-btn btn--block">
      <span>{{ dictionaryData.more }}</span>
    </a>
    <div
      v-if="desktop"
      class="swiper-button-next s-pre-order__next-desktop"></div>
  </div>
</template>

<script>
import { getData } from '../../lib/lib'
import constants from '../../lib/constants'
import { getFormattedDateWithSeparators } from '../../lib/date'
import bookingRedirect from '../../lib/bookingRedirect'
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiper: null,
      preOrderRecords: [],
      dictionaryData: {},
      desktop: false,
      tablet: false,
      mobile: false,
      activeSlideIndex: 0,
    }
  },
  computed: {
    activeRecordUrl() {
      return this.preOrderRecords[this.activeSlideIndex]?.url || '#'
    },
    navigationConfig() {
      if (this.desktop) {
        return {
          nextEl: '.s-pre-order__next-desktop',
          prevEl: '.s-pre-order__prev-desktop',
        }
      }
      return {
        nextEl: '.s-pre-order__next-mobile',
        prevEl: '.s-pre-order__prev-mobile',
      }
    },
  },
  mounted() {
    const { dictionary, records, configuration } = getData('preOrderData')
    this.preOrderRecords = records
    this.dictionaryData = dictionary
    this.config = configuration
    this.assigntoViewports()
    window.addEventListener('resize', () => {
      this.assigntoViewports()
    })
  },
  methods: {
    redirectIntoBooking(movieId) {
      const { redirectIntoBooking } = bookingRedirect()
      redirectIntoBooking(this.config.baseUrl, movieId)
    },
    getGenre(genre) {
      if (typeof genre === 'string') {
        return [genre]
      }
      return genre
    },
    assigntoViewports() {
      this.desktop = constants.is === 'desktop'
      this.tablet = constants.is === 'tablet'
      this.mobile = constants.is === 'mobile'
    },
    showOpenDate(premierDate) {
      return getFormattedDateWithSeparators(
        premierDate,
        'en-GB',
        { year: 'numeric', month: '2-digit', day: '2-digit' },
        '.',
      )
    },
    onSwiper(swiper) {
      this.swiper = swiper
    },
    onSlideChange(swiper) {
      this.activeSlideIndex = swiper.activeIndex
    },
  },
}
</script>
